<template>
  <v-row>
    <v-col v-if="isloading" cols="12" class="justify-center d-flex">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" class="justify-center d-flex">
      <v-chip
        v-if="!Balance.length && !isloading"
        pill
        small
        color="black darken-2"
        text-color="white"
        active-class="green"
        light
        >Empty Balance
        <v-avatar
          size="avatarSize"
          color="error darken-2"
          class="white--text pa-4 my-4"
          right
        >
          000
        </v-avatar>
      </v-chip>
      <v-chip-group column text-color="white" dark>
        <template v-for="(item, index) in Balance">
          <v-chip
            pill
            small
            :color="colorName"
            text-color="white"
            active-class="green"
            light
            :key="index"
            >{{ item.Amount.toLocaleString() }}
            <v-avatar
              size="avatarSize"
              :color="item.Amount < 0 ? '#D50000' : '#FFECB3'"
              :class="item.Amount < 0 ? 'white--text' : 'black--text'"
              class="pa-4 my-4"
              right
            >
              {{ item.AmountType | MoneySigns }}
            </v-avatar>
          </v-chip>
        </template>
      </v-chip-group>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    Balance: { type: Array, default: () => [] },
    isloading: { type: Boolean },
    colorName: { type: String, default: "indigo" },
  },
};
</script>
